import { Loader, type LoaderOptions } from '@googlemaps/js-api-loader';

const options = {
	libraries: ['maps', 'marker', 'geocoding', 'places'],
	client: 'gme-lifetimefitnessinc', // @deprecated. We should use `apiKey`. @see https://developers.google.com/maps/premium/overview
	channel: 'aem-web'
} as LoaderOptions; // Google's type requires `apiKey`, but it works without one

export const loader = new Loader(options);
